import {
  PARSING_RESUME,
  PARSING_RESUME_SUCCESSFUL,
  PARSING_RESUME_FAILED,
  CHECK_DUPLICATE_CANDIDATE,
  CHECK_DUPLICATE_CANDIDATE_SUCCESSFUL,
  CHECK_DUPLICATE_CANDIDATE_FAILED,
  ADD_CANDIDATE,
  ADD_CANDIDATE_SUCCESSFUL,
  ADD_CANDIDATE_FAILED,
  UPDATE_CANDIDATE,
  UPDATE_CANDIDATE_SUCCESSFUL,
  UPDATE_CANDIDATE_FAILED,
  GET_CANDIDATE_DATA,
  GET_CANDIDATE_DATA_SUCCESSFUL,
  GET_CANDIDATE_DATA_FAILED,
  GET_NATIONALITY,
  GET_NATIONALITY_FAILED,
  GET_NATIONALITY_SUCCESSFUL,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATE,
  GET_STATE_SUCCESS,
  GET_STATE_FAILED,
  CANDIDATE_GET_IP_LOCATION,
  CANDIDATE_GET_IP_LOCATION_SUCCESSFULL,
  CANDIDATE_GET_IP_LOCATION_FAILED,
  PERMANENT_GET_STATE,
  PERMANENT_GET_STATE_FAILED,
  PERMANENT_GET_STATE_SUCCESS,
  GET_QUALIFICATION_STATE_FAILED,
  GET_QUALIFICATION_STATE_SUCCESS,
  GET_QUALIFICATION_STATE,
  GET_STATE_AND_COUNTRY_DETAILS, GET_STATE_AND_COUNTRY_DETAILS_SUCCESS ,GET_STATE_AND_COUNTRY_DETAILS_FAIL,
  GET_SECONDARY_STATE_AND_COUNTRY_DETAILS,GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS,GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL
} from "./actionTypes"

const initialState = {
  parsingResumeError: null,
  message: null,
  loading: false,
  user: null,
  fileName:null,
  resumeParsedData:null,
  duplicateCandidate:null,
  duplicateCandidateError:null,
  addNewCandidateData:null,
  addCandidateError:null,
  getCandidatesData:null,
  getCandidateDataError:null,
  getNationality:null,
  getNationalityError:null,
  countriesData:null,
  statesBasedOnCountry:null,
  setIplocation:null,
  setIplocationError:null,
  permanentStatesBasedOnCountry:null,
  qualificationStatesBasedOnCountry:null,
  stateAndCountryDetails: null,
  stateAndCountryErrorMessage: null,
  secondaryStateAndCountryDetails: null

}

const getParsingResume = (state = initialState, action) => {

  switch (action.type) {

   
    case  GET_SECONDARY_STATE_AND_COUNTRY_DETAILS:
      state = {
        ...state,
        loading: true,
        stateAndCountryErrorMessage: null,
      }
      break
    case  GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        secondaryStateAndCountryDetails: action.payload,
        stateAndCountryErrorMessage: null
      }
      break
    case GET_SECONDARY_STATE_AND_COUNTRY_DETAILS_FAIL:
     
      state = {
        ...state,
        secondaryStateAndCountryDetails: null,
        loading: false,
        stateAndCountryErrorMessage: action.payload,
      }
      break



    case  GET_STATE_AND_COUNTRY_DETAILS:
      state = {
        ...state,
        // loading: true,
        stateAndCountryDetails:null,
        stateAndCountryErrorMessage: null,
      }
      break
    case  GET_STATE_AND_COUNTRY_DETAILS_SUCCESS:
      state = {
        ...state,
        // loading: false,
        stateAndCountryDetails: action.payload,
        stateAndCountryErrorMessage: null
      }
      break
    case GET_STATE_AND_COUNTRY_DETAILS_FAIL:
     
      state = {
        ...state,
        stateAndCountryDetails: null,
        // loading: false,
        stateAndCountryErrorMessage: action.payload,
      }
      break



    case PARSING_RESUME:
      state = {
        ...state,
        loading: true,
        parsingResumeError: null,
      }
      break
    case PARSING_RESUME_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        resumeParsedData: action.payload,
        parsingResumeError: null,
      }
      break
    case PARSING_RESUME_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
        parsingResumeError: action.payload,
      }
      break
      case CHECK_DUPLICATE_CANDIDATE:
        state = {
          ...state,
          loading: true,
          duplicateCandidateError: null,
        }
        break
      case CHECK_DUPLICATE_CANDIDATE_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          duplicateCandidate: action.payload,
          duplicateCandidateError: null,
        }
        break
      case CHECK_DUPLICATE_CANDIDATE_FAILED:
       state = {
          ...state,
          duplicateCandidate: null,
          loading: false,
          duplicateCandidateError: action.payload,
        }
        break
        case ADD_CANDIDATE:
        state = {
          ...state,
          loading: true,
          addCandidateError: null,
        }
        break
      case ADD_CANDIDATE_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          addNewCandidateData: action.payload,
          addCandidateError: null,
        }
        break
      case ADD_CANDIDATE_FAILED:
       
        state = {
          ...state,
          addNewCandidateData: null,
          loading: false,
          addCandidateError: action.payload,
        }
        break
        case UPDATE_CANDIDATE:
          state = {
            ...state,
            loading: true,
            updateCandidateError: null,
          }
          break
        case UPDATE_CANDIDATE_SUCCESSFUL:
          state = {
            ...state,
            loading: false,
            updateCandidateData: action.payload,
            updateCandidateError: null,
          }
          break
        case UPDATE_CANDIDATE_FAILED:
         
          state = {
            ...state,
            updateCandidateData: null,
            loading: false,
            updateCandidateError: action.payload,
          }
          break
          case GET_CANDIDATE_DATA:
          state = {
            ...state,
            loading: true,
            getCandidateDataError: null,
          }
          break
        case  GET_CANDIDATE_DATA_SUCCESSFUL:
          state = {
            ...state,
            loading: false,
            getCandidatesData: action.payload,
            getCandidateDataError: null,
          }
          break
        case GET_CANDIDATE_DATA_FAILED:
         
          state = {
            ...state,
            getCandidatesData: null,
            loading: false,
            getCandidateDataError: action.payload,
          }
          break
          case GET_NATIONALITY:
          state = {
            ...state,
            loading: true,
            getCandidateDataError: null,
          }
          break
        case  GET_NATIONALITY_SUCCESSFUL:
          state = {
            ...state,
            loading: false,
            getNationality: action.payload,
            getNationalityError: null,
          }
          break
        case GET_NATIONALITY_FAILED:
         
          state = {
            ...state,
            getNationality: null,
            loading: false,
            getNationalityError: action.payload,
          }
          break
          case GET_COUNTRIES :
            state = { 
              ...state, 
              countriesData:null,
              loading: true
               }
            break
            case GET_COUNTRIES_SUCCESS :
            state = { 
              ...state, 
              countriesData: action.payload.user,
              loading: false
             }
            break
            case GET_COUNTRIES_FAILED :
            state = { 
              ...state, 
              countriesData: null ,
              loading: false
            }
            break
          case GET_STATE :
            state = { 
              ...state, 
              loading: true
               }
            break
            case GET_STATE_SUCCESS :
              state = { 
                ...state, 
                statesBasedOnCountry: action.payload.user,
                loading: false
               }
              break
              case GET_STATE_FAILED :
              state = { 
                ...state, 
                statesBasedOnCountry: null ,
                loading: false
              }
              break
              case CANDIDATE_GET_IP_LOCATION:
                state = {
                  ...state,
                  setIplocation: null,
                  setIplocationError: null,
                  loading:true
                }
                break
              case CANDIDATE_GET_IP_LOCATION_SUCCESSFULL:
                state = {
                  ...state,
                  setIplocation: action.payload,
                  loading:false
                }
                break
              case CANDIDATE_GET_IP_LOCATION_FAILED:
                state = {
                  ...state,
                  setIplocationError: action.payload,
                  loading:false
                }
                break
                case PERMANENT_GET_STATE :
            state = { 
              ...state, 
              loading: true
               }
            break
            case PERMANENT_GET_STATE_SUCCESS :
              state = { 
                ...state, 
                permanentStatesBasedOnCountry: action.payload.user,
                loading: false
               }
              break
              case PERMANENT_GET_STATE_FAILED :
              state = { 
                ...state, 
                permanentStatesBasedOnCountry: null ,
                loading: false
              }
              break
              case GET_QUALIFICATION_STATE :
                state = { 
                  ...state, 
                  loading: true
                   }
                break
                case GET_QUALIFICATION_STATE_SUCCESS :
                  state = { 
                    ...state, 
                    qualificationStatesBasedOnCountry: action.payload.user,
                    loading: false
                   }
                  break
                  case GET_QUALIFICATION_STATE_FAILED :
                  state = { 
                    ...state, 
                    qualificationStatesBasedOnCountry: null ,
                    loading: false
                  }
                  break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getParsingResume
